import './ZonesView.css'
import {useEffect, useRef, useState} from "react";
import axios, {AxiosResponse} from "axios";
import AddressSearch from "./AddressSearch";

export interface ISuggestResult {
    title: ISuggestText
    subtitle: ISuggestText
    lat: number
    lon: number
}

export interface ISuggestText {
    text: string
}

export interface ISuggestResults {
    results: Array<ISuggestResult>
}

interface IEnterAddressProps {
    text: string
    onSelect: (result: ISuggestResult) => void
}

export default function EnterAddressView(props: IEnterAddressProps) {
    const [focused, setFocused] = useState(false);
    const [addresses, setAddresses] = useState<Array<ISuggestResult>>([]);

    let addr = addresses.map((a) => {
        return <a className="Zones_enter_address_item"
                  onMouseDown={(e) => {
                      setFocused(false)
                      props.onSelect(a);
                  }}>{a.title.text}</a>
    });

    return <div className="Zones_enter_address_container">
        <div className='Zones_enter_address_input_container'>
            <AddressSearch
                key={props.text}
                value={props.text}
                onSelectOnMap={() => {
                }}
                showSelectOnMapButton={false}
                onAddressesUpdate={(a) => setAddresses(a)}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}/>
        </div>
        <div className="Zones_enter_address_list">
            {focused && addr}
        </div>
    </div>
}